import React, { Component } from 'react';
import styled from 'styled-components';

/** Custom import's */
import { Subscribe } from '../../store';
import t from '../../application/translate';
import { countries } from '../../containers/CountriesContainer';
import { insuranceStore } from '../../containers/InsuranceCheckingContainer';
import CountrySelector from '../CountrySelector';


// import errorProps from './errorProps';
import Result1 from './results/Result1';
import Result2 from './results/Result2';
import Result3 from './results/Result3';
import Result4 from './results/Result4';

const Wrapper = styled.div.attrs({
  className: 'bg-transparent w-full',
})``;

const InnerWrapper = styled.div.attrs({
  className: 'mx-auto lg:mx-0',
})`
  width: 100%;
  padding: 90px 0 110px 0;
  @media screen and (min-width: 425px){
    width: 460px;
  }
  @media screen and (min-width: 1024px) {
    padding: 90px 0 20px 0;
  }
`;

const Title = styled.div.attrs({
  className: 'text-center lg:text-left text-5xl',
})`
  width: 100%;
  padding: 0 20px;
  @media screen and (min-width: 425px){
    width: 420px;
  }
  @media screen and (min-width: 1024px){
    width: 550px;
    padding-left: 100px;
    padding-right: 60px;
  }
`;

const FormDiv = styled.div.attrs({
  className: 'block',
})`
  width: 100%;
  padding: 40px;
  @media screen and (min-width: 425px){
    width: 460px;
  }
  @media screen and (min-width: 1024px) {
    width: 460px;
    padding: 40px 100px;
  }
`;

const StyledCountrySelector = styled(CountrySelector)`
  .select {
    &__control {
      margin-bottom: 20px;
    }
  }
`;

/**
 * Add Result components to object.
 */
const components = {
  result1: Result1,
  result2: Result2,
  result3: Result3,
  result4: Result4,
};

/**
 * Generate component based on insuracneRelevancyResult
 *
 * @param {Object} props React Props
 */
const Result = ({insuranceResult, components, ...props}) => {
  if(!insuranceResult) return null;
  const Comp = components[`result${insuranceResult}`];
  return (
    <Comp {...props} />
  );
};

class InsuranceCheckingForm extends Component {
 

  render() {
    const { appFolder, language, countriesStore, insuranceStore } = this.props;
    const { countries } = countriesStore.state || {};
    const { citizenship, destination, insuranceRelevancyResult } = insuranceStore.state || null;
    const {
      handleCitizenshipChange,
      handleDestinationChange,
    } = this.props.insuranceStore;

    const {
      getCountryByCode,
    } = this.props.countriesStore;

    

    return (
      <Wrapper>
        <InnerWrapper>
          <Title>{t('insuranceCheckingForm/title')}</Title>
          <FormDiv>
            <StyledCountrySelector
              id="citizenship"
              name="citizenship"
              language={language}
              value={citizenship ? citizenship.twoLetterCode : ''}
              countries={countries}
              onChange={value => {
                handleCitizenshipChange(getCountryByCode(value));
              }}
              // inputProps={{
              //   name: t('insuranceCheckingForm/citizenship'),
              //   id:'citizenship-select'
              // }}
              placeholder={t('insuranceCheckingForm/citizenship')}
              // label={t('insuranceCheckingForm/citizenship')}
            />
                          
            <StyledCountrySelector
              id="destination"
              name="destination"
              language={language}
              value={destination ? destination.twoLetterCode : ''}
              countries={countries}
              onChange={value => {
                handleDestinationChange(getCountryByCode(value));
              }}
              placeholder={t('insuranceCheckingForm/destination')}
              //label={t('insuranceCheckingForm/destination')}
            />
          </FormDiv>
          <Result
            insuranceResult={insuranceRelevancyResult}
            components={components}
            appFolder={appFolder}
          />
        </InnerWrapper>
      </Wrapper>
    );
  }
}

const InsuranceCheckingFormWrapper = (props) => {
  const { language } = props;
  return (
    <Subscribe to={[countries, insuranceStore]}>
      {(countriesStore, insuranceStore) => {
        const { countries, error, isFetching } = countriesStore.state || {};    
        if(!countries.length && !error && !isFetching) {
          countriesStore.fetchCountries(language);
        }
        return (<InsuranceCheckingForm
          countriesStore={countriesStore}
          insuranceStore={insuranceStore}
          {...props}
        />
        );
      }}
    </Subscribe>
  );
};

export default InsuranceCheckingFormWrapper;



// WEBPACK FOOTER //
// ./src/components/InsuranceCheckingForm/InsuranceCheckingForm.js